import util from '../libs/util'
import {login, updatePaswd} from '../biyiadmin/biyi-admin'
import {biyiDicTree} from 'biyi-dic'
import Setting from '@/setting'
import cas from '@/libs/util-cas.js'
import emergencyResponse from '@/views/emergencyResponse/emergencyResponse.vue'

/**
 * 配置静态路由
 * 分为两种路由：
 * 1.路由出口在App.vue
 * 2.路由出口在main.vue
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 * 注意：为避免不必要的错误，每个路由需设置name属性！！！
 */

// 1.路由出口在App.vue
const singleRoutes = [
  {
    // 设置初始页面
    path: '',
    redirect: '/screen'
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    props: {Setting: Setting, cas: cas},
    meta: {
      // 密码规则校验开关
      validatePaswd: true
    }
  },
  {
    path: '/emergeResponse',
    name: 'emergeResponse',
    component: emergencyResponse
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: updatePaswd
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/error-pages/404.vue')
  }
]

/**
 * 路由出口在main.vue，包括了菜单项和非菜单页面
 * 若该页面属于菜单页面，需要添加type: 'menu'属性
 */
const staticTree = [
  {
    path: '/main',
    name: 'main-home',
    title: '项目管理系统',
    icon: 'ios-paper',
    type: 'menu',
    component: () => import('../views/main/main.vue'),
    children: [
      {
        // path: '/home',
        // name: 'home',
        // title: '信息接报',
        // icon: 'ios-paper',
        // // type: 'menu',
        // component: () => import('../views/home/home.vue')
      }
    ]
  },
  // biyiDicTree
]
const staticMenuList = util.getMenuList(staticTree)
const staticMainRoutes = util.getMenuRoutes(staticTree)

// 汇总所有的路由
const staticRoutes = [...staticMainRoutes, ...singleRoutes]

export {staticRoutes, staticMenuList, staticTree}
